import getConfig from 'next/config';

import { Product } from 'models/product';

import { SelectorOption } from '../types/SelectorOption';

export const getSizeOptionsData = ({
  product,
  selectorOptions,
}: {
  product: Product;
  selectorOptions: SelectorOption[];
}) => {
  const { productVersionId } = product;
  const isSomeSizeLastOne = () => selectorOptions.some(current => current.numberAvailable === 1);

  const isLastOneAvailable = () => {
    const nAvailable = selectorOptions.reduce(
      (accumulator, currentValue) => accumulator + currentValue.numberAvailable,
      0,
    );

    return nAvailable === 1;
  };

  const { publicRuntimeConfig } = getConfig();
  const { onlyOneThreshold } = publicRuntimeConfig;
  return {
    isLastOne: +productVersionId % onlyOneThreshold === 0 && isLastOneAvailable(),
    isSomeSizeLastOne: isSomeSizeLastOne(),
    isUniversalSizeOnly: selectorOptions.length === 1 && selectorOptions[0].rawSize === 'U (One-Size)',
  };
};
